<template>
  <b-sidebar
    id="sidebar-vacation-apply-document"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t(applyDocument.status === applyDocumentOnAcademicLeave ? 'Return from vacation': 'Vacation') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />
      </div>
      <validation-observer ref="vacationApplyDocument">
        <!-- Body -->
        <b-form
          class="p-2"
          @submit.prevent
        >

          <b-form-group
            :label="$t('File')"
            label-for="file"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('File')"
              rules="required|file-size:10"
            >
              <b-form-file
                v-model="file"
                :placeholder="$t('Choose a file or drop it here...')"
                accept="application/pdf"
                :drop-placeholder="$t('Drop file here...')"
                :state="errors.length > 0 ? false:null"
                @change="handleFile"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group
            :label="$t('Description')"
            label-for="description"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Description')"
            >
              <b-form-textarea
                id="description"
                v-model="description"
                trim
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              class="mr-2"
              type="submit"
              @click="submit(hide)"
            >
              {{ $t('Submit') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              @click="clear(hide)"
            >
              {{ $t('Cancel') }}
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormTextarea, BButton, BFormFile,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@/libs/validations/validations'
import store from '@/store'

export default {
  components: {
    BFormFile,
    BSidebar,
    BForm,
    BFormGroup,
    BFormTextarea,
    BButton,
    ValidationObserver,
    ValidationProvider,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      description: '',
      file: null,
      base64: null,
      required,
    }
  },
  computed: {
    applyDocument() {
      return this.$store.state[this.MODULE_NAME].applyDocument
    },
  },
  mounted() {
    localize(this.$i18n.locale)
  },
  methods: {
    handleFile(e) {
      // eslint-disable-next-line prefer-destructuring
      this.base64 = e.target.files[0]
    },
    clear(hide) {
      this.$refs.vacationApplyDocument.reset()
      this.description = ''
      this.file = null
      this.base64 = null
      hide()
    },
    submit(hide) {
      this.$refs.vacationApplyDocument.validate().then(success => {
        if (success) {
          this.$removeSwal(this, {
            id: this.applyDocument.id,
            description: this.description,
            file: this.base64,
          }, `${this.MODULE_NAME}/vacation`, () => {
            this.$emit('refetchData')
            this.clear(hide)
          }, {
            text: '',
            confirmButtonText: 'Confirm',
            successTitle: '',
            successText: 'It has been confirmed',
            errorText: 'Not confirmed',
          })
          hide()
        }
      })
    },
  },
  setup() {
    const MODULE_NAME = 'applyDocument'
    const { applyDocumentOnAcademicLeave } = store.state.staticModule
    return {
      applyDocumentOnAcademicLeave,
      MODULE_NAME,
    }
  },
}
</script>
